import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Button, Card, CardContent, CardHeader, Chip, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputBase, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';

import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { GrNext } from "react-icons/gr";

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';

import moment from 'moment';
import "moment/locale/es-mx";

import { DialogBuscarPersona } from '../../../dialogs/DialogBuscarPersona';
import { DialogNuevaPersona } from '../../../dialogs/DialogNuevaPersona';

import { InputSearchStyle, InputSearchButtonsStyle } from '../../../styles/FormStyle';

import { RootState } from '../../../store';
import { openSnackbar } from "../../../store/slices/SnackbarSlice";
import { defaultExpediente, setReducerRecepcion } from '../../../store/slices/RecepcionSlice';

import { ObtenerMateria } from '../../../connections/catalogos/MateriaConnection';
import { ObtenerTipoAmparo } from '../../../connections/catalogos/TipoAmparoConnection';
import { ObtenerAutoridadAmparo } from '../../../connections/catalogos/AutoridadAmparoConnection';
import { ActualizarEstatus, RegistrarInformacion } from '../../../connections/comun/RecepcionConnection';
import { ObtenerAutoridadesMaterias } from '../../../connections/catalogos/AutoridadConnection';

import { PresentanteProps } from '../../../interfaces/comun/PersonaInterface';
import { MateriaProps } from '../../../interfaces/catalogos/MateriaInterface';
import { TipoAmparoProps } from '../../../interfaces/catalogos/TipoAmparoInterface';
import { AutoridadAmparoProps } from '../../../interfaces/catalogos/AutoridadAmparoInterface';
import { AutoridadProps } from '../../../interfaces/catalogos/AutoridadInterface';
import { RegistrarInformacionParams } from '../../../interfaces/comun/RecepcionInterface';
import { BuscarExpediente } from '../../../connections/comun/ExpedienteConnection';
import { ExpedienteProps } from '../../../interfaces/comun/ExpedienteInterface';

interface Props {
    numeroSeguimiento:      number;
    handleNext:             () => void;
}

export const RegistrarInformacionPage = ( { numeroSeguimiento, handleNext } : Props ) => {    

    const dispatch = useDispatch();

    const recepcion = useSelector( ( state: RootState ) => state.recepcion );

    const DateNow = moment( new Date()).format("YYYY-MM-DDTHH:mm");

    const [presentante, setPresentante] = useState<PresentanteProps>( { idPersona: 0, nombreCompleto: '' } );    

    const [materia, setMateria] = useState( 0 );
    const [materiaTemp, setMateriaTemp] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadTemp, setAutoridadTemp] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );
    const [autoridadAllArray, setAutoridadAllArray] = useState<AutoridadProps[]>( [] );

    const [tipoAmparo, setTipoAmparo] = useState( 0 );
    const [tipoAmparoTemp, setTipoAmparoTemp] = useState( 0 );
    const [tipoAmparoArray, setTipoAmparoArray] = useState<TipoAmparoProps[]>( [] );

    const [autoridadAmparo, setAutoridadAmparo] = useState( 0 );
    const [autoridadAmparoTemp, setAutoridadAmparoTemp] = useState( 0 );
    const [autoridadAmparoArray, setAutoridadAmparoArray] = useState<AutoridadAmparoProps[]>( [] );

    const [dirigidoExpediente, setDirigidoExpediente] = useState( false );
    const [numeroAmparoOrigen, setNumeroAmparoOrigen] = useState('');

    const [fechaReloj, setFechaReloj] = useState( DateNow );
    const [recibidoReloj, setRecibidoReloj] = useState( false );   

    const [referencia, setReferencia] = useState( '' );

    const [loadingNext, setLoadingNext] = useState( false );
    const [loadingSave, setLoadingSave] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );

    const [expediente, setExpediente] = useState<ExpedienteProps>( defaultExpediente );

    const [recibidoPaqueteria, setRecibidoPaqueteria] = useState( false );

    const [openDialogNuevaPersona, setopenDialogNuevaPersona] = useState(false);    
    const [openDialogBuscarPersona, setopenDialogBuscarPersona] = useState(false);

    const { idPersona, nombreCompleto } = presentante;

    const seleccionarPersona = ( persona: PresentanteProps ) => setPresentante( persona )    

    const validateFiels = () => {

        let valid = true;
        
        if( idPersona === 0 && !recibidoPaqueteria ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un presentante', variant: 'warning' }));    
        }
        
        if( fechaReloj === '' && recibidoReloj ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar la fecha de reloj', variant: 'warning' }));    
        }
        else if( moment( new Date( fechaReloj ) ) > moment( new Date( ) ) && recibidoReloj ){
            valid = false;
            dispatch( openSnackbar({ message: 'La fecha de reloj no puede ser mayor a la fecha actual', variant: 'warning' }));    
        }                
        
        if( tipoAmparo === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de amparo', variant: 'warning' }));   
        }
        
        if( autoridadAmparo === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar la autoridad de amparo', variant: 'warning' }));   
        }       
        
        if( numeroAmparoOrigen === '' && tipoAmparo === 2 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes escribir el número de amparo de origen', variant: 'warning' }));   
        } 
        
        if( materia === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar la materia', variant: 'warning' }));   
        }      
        
        if( autoridad === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar ls autoridad', variant: 'warning' }));   
        }      
        
        if( ( expediente.idExpediente === 0 && tipoAmparo === 1 ) || ( expediente.idExpediente === 0 && tipoAmparo === 2 && dirigidoExpediente ) ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes buscar el expediente para poder continuar', variant: 'warning' }));     
        }  

        return valid;
    } 

    const Guardar = async () => {

        const params: RegistrarInformacionParams = { 
            id: recepcion.id ?? '', 
            fechaReloj: recibidoReloj ? fechaReloj : '', 
            idMateria: materia, 
            idPresentante: idPersona, 
            recibidoPaqueteria: recibidoPaqueteria, 
            recibidoPorReloj: recibidoReloj,
            idExpediente: expediente.idExpediente,
            idAutoridad: autoridad,
            idTipoAmparo: tipoAmparo,
            idAutoridadAmparo: autoridadAmparo,
            dirigidoExpediente: dirigidoExpediente,
            numeroAmparoOrigen: numeroAmparoOrigen,
        };

        const request = await RegistrarInformacion( params );  

        if( request.success ){

            const materiaDescripcion = materiaArray.find( (e) => e.idMateria === materia )?.descripcion ?? '';
            const autoridadAmparoDescripcion = autoridadAmparoArray.find( (e) => e.idAutoridadAmparo === autoridadAmparo )?.descripcion ?? '';
            const tipoAmparoDescripcion = tipoAmparoArray.find( (e) => e.idTipoAmparo === tipoAmparo )?.descripcion ?? '';

            let autoridadDescripcion = '';
            let juzgadoOrigenDescripcion = '';

            const autoridadFind = autoridadAllArray.find( (e) => e.asignacion === true );

            if( autoridadFind ){
                autoridadDescripcion = autoridadFind?.descripcion ?? '';

                if( autoridadFind.idAutoridad !== autoridad ){
                    juzgadoOrigenDescripcion = autoridadAllArray.find( (e) => e.idAutoridad === autoridad )?.descripcion ?? '';
                }

            }

            dispatch( setReducerRecepcion({ 
                ...recepcion, 
                ...params, 
                materia: materiaDescripcion, 
                autoridad: autoridadDescripcion,
                juzgadoOrigen: juzgadoOrigenDescripcion,
                tipoAmparo: tipoAmparoDescripcion,
                autoridadAmparo: autoridadAmparoDescripcion,
                presentante: recibidoPaqueteria ? 'Enviado por paquetería' : nombreCompleto, 
                numeroExpediente: expediente.numeroExpediente,
                expediente: expediente,
            }));
        }

        return request;
    }

    const handleGuardar = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingSave( true );

        await Guardar().then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingSave( false );

                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' }));   
                    setLoadingSave( false );

                }, 700);

            }

        });       

    }

    const handleSiguiente = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingNext( true );

        if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){          
                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'warning' }));   
                    setLoadingNext( false );
    
                }, 700);
            }

        }

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 4 }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingNext( false );
                    handleNext();

                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' }));   
                    setLoadingNext( false );

                }, 700);

            }

        });       

    }

    const handleBuscarExpediente = async () => {
    
        setLoadingSearch( true );

        await BuscarExpediente({ idAutoridad: autoridad, numeroExpediente: referencia }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setReferencia( '' );
                    setExpediente( resp );
                    setLoadingSearch( false );

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' }));   
                    setReferencia( '' );
                    setExpediente( resp );
                    setLoadingSearch( false );

                }, 700);

            }

        });       

    }    

    const handleChangeTipoAmparo = ( value: number ) => {

        setTipoAmparo( value ); 
        setAutoridadAmparo( 0 );
        setAutoridad( 0 );
        setExpediente( defaultExpediente ); 
        setDirigidoExpediente( false );

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerMateria().then( resp => {  
                setMateriaArray( resp );    
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){

            setTipoAmparo( 0 );
            setTipoAmparoArray( [] );        

            await ObtenerTipoAmparo().then( resp => {  
                setTipoAmparoArray( resp );    
            });                  

        }

        Obtener();

    }, []);
   
    useEffect(() => {
        
        async function Obtener(){

            setAutoridadAmparo( 0 );
            setAutoridadAmparoArray( [] );           

            await ObtenerAutoridadAmparo().then( resp => {  
                setAutoridadAmparoArray( resp );    
            });

        }

        Obtener();

    }, []);

    useEffect(() => {
        
        async function Obtener(){

            setAutoridad( 0 );
            setAutoridadArray( [] );           

            if( materia !== 0 ){
                
                await ObtenerAutoridadesMaterias( materia ).then( resp => {  
                    setAutoridadArray( resp );    
                    setAutoridadAllArray( resp );    
                });                   

            }

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {
        
        if( recepcion.id ){

            setRecibidoPaqueteria( recepcion.recibidoPaqueteria ?? false );
            setRecibidoReloj( recepcion.recibidoPorReloj ?? false );
            setFechaReloj( recepcion.fechaReloj ?? '' );

            setPresentante( { idPersona: recepcion.idPresentante ?? 0, nombreCompleto: recepcion.presentante ?? '', } );

            setMateriaTemp( recepcion.idMateria ?? 0 );
            setAutoridadTemp( recepcion.idAutoridad ?? 0 );
            
            setTipoAmparoTemp( recepcion.idTipoAmparo ?? 0 );
            setAutoridadAmparoTemp( recepcion.idAutoridadAmparo ?? 0 );
            setDirigidoExpediente( recepcion.dirigidoExpediente ?? false );
            setNumeroAmparoOrigen( recepcion?.numeroAmparoOrigen ?? '' );

            setExpediente( recepcion.expediente ?? defaultExpediente );

        }

    }, [ recepcion ]);

    useEffect(() => {
        
        if( materiaArray.length !== 0 && materiaTemp !== 0 ){
            setMateria( materiaTemp );
        }

    }, [ materiaArray, materiaTemp ]);

    useEffect(() => {
        
        if( autoridadArray.length !== 0 && autoridadTemp !== 0 ){
            setAutoridad( autoridadTemp );
        }

    }, [ autoridadArray, autoridadTemp ]);

    useEffect(() => {
        
        if( tipoAmparoArray.length !== 0 && tipoAmparoTemp !== 0 ){
            setTipoAmparo( tipoAmparoTemp );
        }

    }, [ tipoAmparoArray, tipoAmparoTemp ]);

    useEffect(() => {
        
        if( autoridadAmparoArray.length !== 0 && autoridadAmparoTemp !== 0 ){
            setAutoridadAmparo( autoridadAmparoTemp );
        }

    }, [ autoridadAmparoArray, autoridadAmparoTemp ]);
       
    return (
        <>
            <Grid container spacing={3}>    

                <Grid size={{ md: 12, xs: 12 }}>       

                    <Card sx={{ mt: 2 }}>
                    
                        <CardHeader 
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }} 
                            subheader={ 
                                <Grid container spacing={3}>

                                    <Grid size={{ md: 6, xs: 6 }}>                                                                    
                                        <Typography variant='h6' sx={{ color: 'white' }}> Registrar información </Typography> 
                                    </Grid>
                                
                                    <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: 'end' }}>
                                        <Chip variant='filled' sx={{ bgcolor: 'white', borderRadius: 2, p: 2 }} label={ <Typography variant='h6'> RT-{ numeroSeguimiento } </Typography>  } />
                                    </Grid>

                                </Grid>
                            }
                        />
                    
                        <CardContent sx={{ p: 3 }}>
                        
                            <Grid container spacing={3}>   
                                
                                <Grid size={{ md: !recibidoPaqueteria ? 4 : 12, xs: 12 }}>

                                    <FormControl disabled={ recepcion.acuseFirmado !== '' }>

                                        <FormLabel>¿El trámite es recibido por paquetería?</FormLabel>
                                        <RadioGroup row>
                                            <FormControlLabel control={ <Radio checked={ recibidoPaqueteria === false } onChange={ ( e ) => { setRecibidoPaqueteria( false ); setPresentante({ idPersona: 0, nombreCompleto: '' }); } } />} label="No" />
                                            <FormControlLabel control={ <Radio checked={ recibidoPaqueteria === true } onChange={  ( e ) => { setRecibidoPaqueteria( true); setPresentante({ idPersona: 0, nombreCompleto: '' }); } } />} label="Si" />
                                        </RadioGroup>

                                    </FormControl>

                                </Grid>

                                {
                                    !recibidoPaqueteria
                                    &&
                                        <Grid size={{ md: 8, xs: 12 }} > 

                                            {
                                                !recepcion.acuseFirmado
                                                ?
                                                    <Paper component="div" sx={ InputSearchStyle } >    

                                                        <InputBase 
                                                            sx={{ ml: 1, flex: 1 }} 
                                                            inputProps={{ 'aria-label': 'Buscar presentante' }} 
                                                            placeholder="Buscar presentante"     
                                                            value={ nombreCompleto }   
                                                            onChange={ () => {} }             
                                                            autoComplete="off"   
                                                            disabled
                                                        /> 
                                                    
                                                        <Button 
                                                            size='small'
                                                            variant='contained' 
                                                            sx={ InputSearchButtonsStyle } 
                                                            disabled={ recibidoPaqueteria }
                                                            onClick={ () => setopenDialogBuscarPersona( true ) }
                                                        >
                                                            <SearchIcon />
                                                        </Button>     
                                                            
                                                        <Button 
                                                            variant='contained' 
                                                            size='small'
                                                            sx={ InputSearchButtonsStyle } 
                                                            disabled={ recibidoPaqueteria }
                                                            onClick={ () => setopenDialogNuevaPersona( true ) }
                                                        >
                                                            <PersonAddIcon />
                                                        </Button>     

                                                    </Paper> 
                                                :
                                                    <>
                                                        <Typography variant='subtitle2' color='textSecondary'>Presentante:</Typography>
                                                        <Typography variant='subtitle2' color='textSecondary'>{ nombreCompleto }</Typography>                                                    
                                                    </>
                                            }

                                        </Grid>                      
                                }          

                                <Grid size={{ md: 6, xs: 12 }}>  

                                    <FormControl disabled={ recepcion.acuseFirmado !== '' }>

                                        <FormLabel>¿El trámite es recibido por reloj?</FormLabel>
                                        <RadioGroup row>
                                            <FormControlLabel control={ <Radio checked={ recibidoReloj === true } onChange={ () => { setRecibidoReloj( true ); setFechaReloj( DateNow ); }} />} label="Si" />                        
                                            <FormControlLabel control={ <Radio checked={ recibidoReloj === false } onChange={ () => setRecibidoReloj( false ) } />} label="No" />    
                                        </RadioGroup>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 6, xs: 12 }}>                            

                                    {
                                        recibidoReloj 
                                        && 
                                            <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es"> 

                                                <DateTimePicker                                        
                                                    label="Fecha de recepción por reloj"       
                                                    sx={{ width: '100%' }}  
                                                    disabled={ recepcion.acuseFirmado !== '' }
                                                    value={ moment( fechaReloj ) }
                                                    maxDate={ moment( new Date() ) }
                                                    onChange={ (e) => setFechaReloj( moment( e ).format( 'YYYY-MM-DDTHH:mm' ) ) }
                                                />    

                                            </LocalizationProvider>                                            
                                    }

                                </Grid>  

                                <Grid size={{ md: 6, xs: 12 }}>                            
                                
                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de amparo</InputLabel>
                                    
                                        <Select                                                                                  
                                            label="Tipo de amparo"
                                            value={ tipoAmparo }
                                            onChange={ (e) => handleChangeTipoAmparo( e.target.value ) }
                                            disabled={ recepcion.acuseFirmado !== '' }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                            {
                                                tipoAmparoArray.map( ({ idTipoAmparo, descripcion  }) => (
                                                    <MenuItem key={idTipoAmparo} value={idTipoAmparo}>{ descripcion }</MenuItem>   
                                                ))
                                            }
                                        </Select>

                                    </FormControl>
                                
                                </Grid> 
                                
                                <Grid size={{ md: 6, xs: 12 }}>                            
                                
                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad de amparo</InputLabel>
                                    
                                        <Select                                                                     
                                            label="Autoridad de amparo"
                                            value={ autoridadAmparo }
                                            onChange={ (e) => setAutoridadAmparo( e.target.value )  }
                                            disabled={ recepcion.acuseFirmado !== '' || tipoAmparo === 0 }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                            {
                                                tipoAmparo === 1
                                                &&
                                                    autoridadAmparoArray
                                                    .filter( ( elem ) => {
                                                        return elem.idAutoridadAmparo === 2;
                                                    })
                                                    .map( ( element ) => (
                                                        <MenuItem key={ element.idAutoridadAmparo } value={ element.idAutoridadAmparo }>{ element.descripcion }</MenuItem>                        
                                                    ))
                                            } 
                                            {
                                                tipoAmparo === 2
                                                &&
                                                    autoridadAmparoArray
                                                    .filter( ( elem ) => {
                                                        return elem.idAutoridadAmparo === 1;
                                                    })
                                                    .map( ( element ) => (
                                                        <MenuItem key={ element.idAutoridadAmparo } value={ element.idAutoridadAmparo }>{ element.descripcion }</MenuItem>                        
                                                    ))
                                            } 
                                        </Select>

                                    </FormControl>
                                
                                </Grid> 

                                {
                                    tipoAmparo === 2
                                    &&
                                        <>
                                            <Grid size={{ md: 6, xs: 12 }}>    

                                                <FormControl disabled={ recepcion.acuseFirmado !== '' }>

                                                    <FormLabel>¿El amparo va dirigido a un expediente?</FormLabel>
                                                    <RadioGroup row>
                                                        <FormControlLabel control={ <Radio checked={ dirigidoExpediente === false } onChange={ () => { setDirigidoExpediente( false ); setAutoridad( 0 ); setExpediente( defaultExpediente ); } } />} label="No" />
                                                        <FormControlLabel control={ <Radio checked={ dirigidoExpediente === true } onChange={ () => { setDirigidoExpediente( true ); setAutoridad( 0 ); setExpediente( defaultExpediente ); } } />} label="Si" />   
                                                    </RadioGroup>

                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>    
                                                
                                                <TextField                              
                                                    fullWidth       
                                                    label="Número de amparo de origen"
                                                    autoComplete='off'                      
                                                    value={ numeroAmparoOrigen }    
                                                    onChange={ ( e ) => { setNumeroAmparoOrigen( e.target.value ); } }                                                     
                                                    disabled={ recepcion.acuseFirmado !== '' }
                                                    slotProps={{
                                                        input: {
                                                            autoComplete: 'off'
                                                        },
                                                        inputLabel: {
                                                            shrink: true,
                                                        }
                                                    }}        
                                                />

                                            </Grid>
                                        </>
                                }

                                <Grid size={{ md: 12, xs: 12 }}>       

                                    <FormControl disabled={ recepcion.acuseFirmado !== '' }>

                                        <FormLabel>Seleccione la materia</FormLabel>
                                        <RadioGroup row>
                                            {
                                                materiaArray
                                                .map( ({ idMateria, descripcion }) => (
                                                    <FormControlLabel 
                                                        key={ idMateria }
                                                        label={ descripcion }
                                                        control={ <Radio checked={ materia === idMateria } 
                                                        onChange={ () => { setMateria( idMateria ); setAutoridad(0); setExpediente( defaultExpediente ); }} />} 
                                                    />                        
                                                ))
                                            }                                      
                                        </RadioGroup>

                                    </FormControl>

                                </Grid>       

                                <Grid size={{ md: ( ( tipoAmparo === 1 || ( tipoAmparo === 2 && dirigidoExpediente ) ) && recepcion.acuseFirmado === '' ) ? 6 : 12, xs: 12 }}>                            
                                                            
                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>
                                    
                                        <Select                                                                          
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value )  }
                                            disabled={ recepcion.acuseFirmado !== '' || materia === 0 }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                            {
                                                ( dirigidoExpediente || tipoAmparo === 1 )
                                                ?
                                                    autoridadArray
                                                    .map( ({ idAutoridad, descripcion }) => (
                                                        <MenuItem key={idAutoridad} value={idAutoridad}>{ descripcion }</MenuItem>   
                                                    ))
                                                : 
                                                    autoridadArray
                                                    .filter( ({ asignacion }) => asignacion === true )
                                                    .map( ({ idAutoridad, descripcion }) => (
                                                        <MenuItem key={idAutoridad} value={idAutoridad}>{ descripcion }</MenuItem>   
                                                    ))
                                            }                                            
                                        </Select>

                                    </FormControl>
                                
                                </Grid>  

                                {
                                    ( ( tipoAmparo === 1 || ( tipoAmparo === 2 && dirigidoExpediente ) ) && recepcion.acuseFirmado === '' )
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}> 
                                                                    
                                            <Paper component="div" sx={ InputSearchStyle }>                            
                                                
                                                <InputBase 
                                                    sx={{ ml: 1, flex: 1 }} 
                                                    placeholder={ "Buscar por número de expediente" } 
                                                    autoComplete="off"
                                                    disabled={ autoridad === 0 }
                                                    value={ referencia }
                                                    onChange={ (e) => setReferencia( e.target.value ) }
                                                /> 

                                                <Button 
                                                    variant='contained' 
                                                    size='small'
                                                    sx={ InputSearchButtonsStyle } 
                                                    disabled={  recepcion.acuseFirmado !== '' || autoridad === 0 || referencia === '' }
                                                    loading={ loadingSearch }
                                                    onClick={ handleBuscarExpediente }
                                                >
                                                    <SearchIcon />
                                                </Button>   

                                            </Paper>

                                        </Grid>  
                                }

                                {
                                    expediente.idExpediente !== 0
                                    &&
                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <Grid container spacing={3}>

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } </Typography>                                            

                                                </Grid>
                                            
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                        
                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> 
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.tipoJuicio } </Typography>                                                   

                                                </Grid>

                                                {
                                                    expediente.actor.length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                            
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.actor.join(', ') } </Typography> 

                                                        </Grid>
                                                }

                                                {
                                                    expediente.demandado.length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.demandado.join(', ') } </Typography> 

                                                        </Grid>
                                                }

                                            </Grid>
                                        
                                        </Grid>
                                }
                                
                            </Grid> 

                        </CardContent>
                    
                    </Card>  
                
                </Grid>

                <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>  

                    <Grid container spacing={3}>

                        <Grid size={{ md: 4, xs: 12 }}>

                        </Grid>
                    
                        <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center '}}>

                            {
                                !recepcion.acuseFirmado
                                &&
                                    <Button 
                                        fullWidth
                                        variant="contained"                                      
                                        onClick={ handleGuardar }
                                        loading={ loadingSave }
                                    > 
                                        Guardar 
                                    </Button>
                            }

                        </Grid>
                    
                        <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'end '}}>

                            <IconButton     
                                color='primary'                     
                                onClick={ handleSiguiente }
                                loading={ loadingNext }
                            > 
                                <GrNext />
                            </IconButton>

                        </Grid>

                    </Grid>              

                </Grid>

            </Grid> 

            <DialogNuevaPersona 
                openDialog={ openDialogNuevaPersona } 
                handleCloseDialog={ () => setopenDialogNuevaPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona } 
                handleCloseDialog={ () => setopenDialogBuscarPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            /> 
        
        </>        
    );
}
